import React, { useState } from 'react';
import {Carousel, Modal} from 'react-bootstrap';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ProjectGridComponent.css';

const ProjectGridComponent = ({ imagesInfo }) => {

  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(0);

  function handleShow(index) {
    if (window.innerWidth > 480) {
      setShow(true);
      setIndex(index);
    }
  }

  function handleClose() {
    setShow(false);
  }

  function handleSelect(index) {
    setIndex(index);
  }

  function handleOverlayClick(e) {
    if (!e.target.classList[0].includes('carousel-control')) {
      handleClose();
    }
  };

  return (
    <>
    <div className='grid-wrapper p-2'>
      <div className='grid-container px-2'>
          {imagesInfo.map((imageInfo, index) => (
            <div className='image-container mb-1' key={index}>
              <img src={imageInfo.src} alt={imageInfo.alt} onClick={() => handleShow(index)}/>
            </div>
          ))}
        </div>
    </div>
 
        
      <Modal 
        className="modal" 
        show={show} 
        onHide={handleClose}
      >
        <div className="modal-overlay" onClick={handleOverlayClick}>
          <Modal.Body>
            <Carousel activeIndex={index} onSelect={handleSelect}>
              {imagesInfo.map((image, i) => (
                <Carousel.Item key={i}>
                  <img className="modal-image d-block w-100" src={image.src} alt={image.alt} />
                </Carousel.Item>
              ))}
            </Carousel>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

ProjectGridComponent.propTypes = {
  imagesInfo: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ProjectGridComponent;